import FolderService from '../services/folderService'
import { objectToFolder } from './folderStoreUtils'

export default {
  namespaced: true,
  state: () => ({
    folders: [],
    folderItemKey: 'idCarpeta',
    folderItemText: 'nombre',
    folderRoot: null,

    isTableBusy: false,
    isDeleting: false,
    tableLabels: {
      loadingText: 'Buscando las carpetas...',
      noDataText: 'No hay carpetas'
    },
    folderDeleteLabels: {
      questionText: '¿Estás seguro que deseas eliminar la carpeta: @?',
      descriptionText:
        'El borrado eliminará permanentemente la carpeta y no podrá deshacerse.',
      positiveButtonText: 'Eliminar',
      negativeButtonText: 'Cancelar'
    },
    folderUnselected:
      'Primero debe seleccionar el directorio padre donde quiere crear la nueva carpeta.',
    codeFolderServicePost200: 'FOLDER-POST-200',
    codeFolderServicePut200: 'FOLDER-PUT-200',
    codeFolderServiceDelete200: 'FOLDER-DELETE-200',
    msgFolderServiceError:
      'No se pudo realizar la operación solicitada sobre la carpeta.',
    msgFolderServiceDeleteError: 'La carpeta no pudo ser eliminada.'
  }),
  mutations: {
    SET_FOLDERS(state, folders) {
      state.folders = folders
    },
    SET_FOLDER_ROOT(state, id) {
      state.folderRoot = id
    },
    SET_TABLE_BUSY(state, isBusy) {
      state.isTableBusy = isBusy
    },
    SET_IS_DELETING(state, isDeleting) {
      state.isDeleting = isDeleting
    }
  },
  actions: {
    tableBusy({ commit }) {
      commit('SET_TABLE_BUSY', true)
    },
    tableUnnocupied({ commit }) {
      commit('SET_TABLE_BUSY', false)
    },
    deleteBusy({ commit }) {
      commit('SET_IS_DELETING', true)
    },
    deleteUnnocupied({ commit }) {
      commit('SET_IS_DELETING', false)
    },
    getFolders({ commit }) {
      const service = new FolderService()
      commit('SET_FOLDERS', [])
      commit('SET_FOLDER_ROOT', null)
      commit('SET_TABLE_BUSY', true)
      
      return new Promise((resolve, reject) => {
        service
          .getFolders()
          .then(result => {
            if (result.data.successful.code == 'FOLDER-GET-200') {
              if (result.data.data.length > 0) {
                let newList = objectToFolder(result.data.data, [])
                commit('SET_FOLDERS', newList)
                let f = result.data.data[0]
                commit('SET_FOLDER_ROOT', f.idCarpeta)
              }
              resolve(result.data.successful.code)
            } else {
              reject(result)
            }
          })
          .catch(err => {
            reject(err)
          })
          .finally(() => {
            commit('SET_TABLE_BUSY', false)
          })
      })
    },
    async createFolder({ state }, data) {
      const service = new FolderService()
      return service.createFolder(data)
    },
    async updateFolder({ commit }, data) {
      const service = new FolderService()
      data = Object.assign({}, data)
      const id = data.idCarpeta
      delete data['idCarpeta']
      return service.updateFolder(id, data)
    },
    async deleteFolder({ commit }, data) {
      const service = new FolderService()
      return service.deleteFolder(data)
    },
    cleanedForm({ commit }) {
      commit('SET_CLEAN_FORM', false)
    }
  },
  getters: {
    folders(state) {
      return state.folders
    },
    folderItemKey(state) {
      return state.folderItemKey
    },
    folderItemText(state) {
      return state.folderItemText
    },
    folderRoot(state) {
      return state.folderRoot
    },
    isTableBusy(state) {
      return state.isTableBusy
    },
    loadingText(state) {
      return state.tableLabels.loadingText
    },
    noDataText(state) {
      return state.tableLabels.noDataText
    },
    folderDeleteLabels(state) {
      return state.folderDeleteLabels
    },
    isDeleting(state) {
      return state.isDeleting
    },
    messageFolderUnselected(state) {
      return state.folderUnselected
    },
    codeFolderServicePost200(state) {
      return state.codeFolderServicePost200
    },
    codeFolderServicePut200(state) {
      return state.codeFolderServicePut200
    },
    codeFolderServiceDelete200(state) {
      return state.codeFolderServiceDelete200
    },
    msgFolderServiceError(state) {
      return state.msgFolderServiceError
    },
    msgFolderServiceDeleteError(state) {
      return state.msgFolderServiceDeleteError
    }
  }
}
